import "./productDescriptionRight.scss";

import React, { useContext, useState } from "react";

import Button from "../../atoms/button/button";
import { GatsbyImage } from "gatsby-plugin-image";
import GlobalContext from "../../../contexts/globalContext";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// Components //

// Styles //

const productDescriptionRight = (props: ReferenciaContenido) => {
  const { tituloGeneral, descripcion } = props;
  const globalContext = useContext(GlobalContext);
  const [showFullText, setShowFullText] = useState(false);

  const toggleTexto = () => {
    setShowFullText(!showFullText);
  };

  const options = {
   renderNode: {
     paragraph: (node) => (
       <span style={{display: 'inline-block', marginBottom: '1rem'}}>
         {node.content[0]?.value}
       </span>
     ),
   },
 };

  return (
    <div className={`o-product-description-right`}>
      <div className={`container`}>
        <div className="product-description-right-item">
          <div className="product-description-right-item__video_mobile">
            <GatsbyImage
              className="video"
              image={props.imagenPrincipal.gatsbyImageData}
              alt="imagen producto"
            />
          </div>
          <div className="product-description-right-item__text">
            <h3>{tituloGeneral}</h3>
            {
              <p
                className={
                  "o-product-description-right__p " +
                  (showFullText ? "full-content" : "content")
                }
              >
                {documentToReactComponents(
                  JSON.parse(descripcion?.raw),
                  options
                )}
                {!showFullText && (
                  <span className="o-product-description-right__degrade"></span>
                )}
              </p>
            }
            <div className="o-product-description-right__button-see">
              <button onClick={toggleTexto}>
                {showFullText ? (
                  <svg
                    height="24"
                    fill="#c4c4c6"
                    viewBox="0 0 24 13"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m0 0h24v24h-24z" fill="none" />
                    <path d="m7.41 15.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
                  </svg>
                ) : (
                  <svg
                    height="24"
                    fill="#c4c4c6"
                    viewBox="0 0 24 13"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m0 0h24v24h-24z" fill="none" />
                    <path d="m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
                  </svg>
                )}
                {showFullText ? "Ver menos" : "Ver más"}
              </button>
            </div>
            <Button
              type="button"
              text={props.tituloBoton}
              classname={`secondary`}
              isDisabled={false}
              onClickAction={() => {
                props.validarAutenticacion === false
                  ? (window.location.href = `${window.location.origin}${window.location.pathname}${props.redireccionBoton}`)
                  : props.validarAutenticacion == null
                  ? globalContext.gigyaContext.gigyaAccount
                    ? (window.location.href = `${window.location.origin}${window.location.pathname}${props.redireccionBoton}`)
                    : globalContext.gigyaContext.login()
                  : null;
              }}
            />
          </div>
          <div className="product-description-right-item__video">
            <GatsbyImage
              className="video"
              image={props.imagenPrincipal.gatsbyImageData}
              alt="imagen producto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default productDescriptionRight;
